@layer module {
.iban-flow-overlay {
            position: fixed;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 3000;
            overflow-y: auto;
    }

.iban-flow-modal {
            position: relative;
    }

.iban-flow-close {
            position: absolute;
            z-index: 5;
    }

.iban-flow-head {
            text-align: center;
    }

.iban-stepper {
            display: flex;
            align-items: center;
            justify-content: center;
    }

.iban-step {
            display: flex;
            align-items: center;
    }

.iban-step-marker,
.iban-choice-check,
.iban-warn-icon,
.iban-status-icon {
            display: grid;
            place-items: center;
    }

.iban-step-marker {
            border-width: 1.5px;
            border-style: solid;
    }

.iban-step-view {
            animation: iban-fade-in 0.22s ease;
    }

@keyframes iban-fade-in {
from {
            opacity: 0;
            transform: translateY(4px);
    }

to {
            opacity: 1;
            transform: none;
    }
}

.iban-setup-section {
            border-bottom-width: 1px;
            border-bottom-style: solid;
            transition: opacity 0.2s;
    }

.iban-setup-section.disabled {
            opacity: 0.4;
            pointer-events: none;
    }

.iban-section-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.iban-section-title {
            display: flex;
            align-items: center;
    }

.iban-section-badge {
            flex-shrink: 0;
    }

.iban-network-row {
            display: grid;
            grid-template-columns: 1fr 1fr;
    }

.iban-choice-card {
            border-width: 1.5px;
            border-style: solid;
            cursor: pointer;
            transition: all 0.15s;
            display: flex;
            align-items: center;
    }

.iban-net-icon {
            display: grid;
            place-items: center;
            flex-shrink: 0;
    }

.iban-choice-info {
            flex: 1;
            min-width: 0;
    }

.iban-choice-check {
            flex-shrink: 0;
    }

.iban-ccy-grid {
            display: flex;
            flex-wrap: wrap;
    }

.iban-acct-list {
            display: flex;
            flex-direction: column;
    }

.iban-acct-empty {
            text-align: center;
    }

.iban-acct-create {
            transition: all 0.15s;
    }

.iban-fee-strip {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
    }

.iban-fee-strip-note {
            flex: 1;
    }

.iban-fee-strip-values {
            text-align: right;
            flex-shrink: 0;
    }

.iban-fee-strip-row,
.iban-fee-row {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
    }

.iban-btn-row {
            display: flex;
    }

.iban-btn-row > * {
            flex: 1;
    }

.iban-confirm-grid {
            display: grid;
            grid-template-columns: 1.15fr 1fr;
    }

.iban-fee-row.total {
            border-top-width: 1px;
            border-top-style: dashed;
    }

.iban-free-banner,
.iban-warn-banner {
            border-width: 1px;
            border-style: solid;
    }

.iban-warn-banner {
            display: flex;
            align-items: flex-start;
    }

.iban-warn-icon {
            flex-shrink: 0;
    }

.iban-summary-row,
.iban-detail-row {
            display: flex;
            justify-content: space-between;
            border-bottom-width: 1px;
            border-bottom-style: solid;
    }

.iban-summary-row {
            align-items: center;
    }

.iban-summary-row:last-child,
.iban-detail-row:last-child {
            border-bottom: none;
    }

.iban-summary-val {
            display: flex;
            align-items: center;
    }

.iban-fine-print {
            text-align: center;
    }

.iban-fine-print .iban-link {
            cursor: pointer;
    }

.iban-ghost-back:disabled {
            opacity: 0.5;
            cursor: not-allowed;
    }

.iban-questionnaire-form {
            display: grid;
            grid-template-columns: 1fr 1fr;
    }

.iban-questionnaire-form .iban-q-full {
            grid-column: 1 / -1;
    }

.iban-field {
            display: flex;
            flex-direction: column;
    }

.iban-status-body {
            text-align: center;
    }

.iban-display {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.iban-string {
            word-break: break-all;
            text-align: left;
    }

.iban-copy-btn {
            flex-shrink: 0;
    }

.iban-details {
            text-align: left;
            border-width: 1px;
            border-style: solid;
            overflow: hidden;
    }

.iban-detail-value {
            text-align: right;
            word-break: break-word;
    }

.iban-status-actions {
            display: flex;
            flex-direction: column;
    }

.iban-fee-terms-body {
            overflow-y: auto;
    }

      @media (max-width: 640px) {
                .iban-confirm-grid {
                        grid-template-columns: 1fr;
                    }
          }

      @media (max-width: 560px) {
                .iban-questionnaire-form {
                        grid-template-columns: 1fr;
                    }
          }

      @media (max-width: 520px) {
                .iban-network-row {
                        grid-template-columns: 1fr;
                    }
          }

      @media (max-width: 480px) {
                .iban-fee-strip {
                        flex-direction: column;
                    }

                .iban-fee-strip-values {
                        text-align: left;
                    }

                .iban-fee-strip-row {
                        justify-content: flex-start;
                    }
          }
} // layer module










@layer app {
.iban-flow-overlay {
            inset: 0;
            padding: $size-15;
    }

.iban-flow-modal {
            width: 100%;
            max-width: $size-760;
            border-radius: $size-18;
            margin: auto;
    }

.iban-flow-close {
            top: $size-neg-18;
            right: $size-neg-18;
    }

.iban-flow-inner {
            padding: $size-20 $size-22-5;
    }

.iban-stepper {
            gap: $size-12;
            margin: $size-8-75 0 $size-15;
    }

.iban-step {
            gap: $size-8;
    }

.iban-step-marker,
.iban-choice-check,
.iban-warn-icon,
.iban-status-icon {
            border-radius: 50%;
    }

.iban-step-marker svg {
            width: $size-11;
            height: $size-11;
    }

.iban-step-num {
            width: $size-24;
            height: $size-24;
    }

.iban-setup-section {
            padding: $size-11-25 0;
    }

.iban-setup-section:first-child {
            padding-top: 0;
    }

.iban-section-header {
            margin-bottom: $size-7-5;
    }

.iban-section-title {
            gap: $size-10;
    }

.iban-section-badge {
            width: $size-22;
            height: $size-22;
    }

.iban-network-row {
            gap: $size-12;
    }

.iban-choice-card {
            border-radius: $size-12;
            gap: $size-12;
    }

.iban-net-card {
            padding: $size-13 $size-15;
    }

.iban-net-icon {
            width: $size-36;
            height: $size-36;
            border-radius: $size-8;
    }

.iban-net-sub {
            margin-top: 1px;
    }

.iban-choice-check {
            width: $size-18;
            height: $size-18;
    }

.iban-choice-check svg {
            width: $size-10;
            height: $size-10;
    }

.iban-ccy-grid {
            gap: $size-10;
    }

.iban-acct-list {
            gap: $size-10;
    }

.iban-acct-card {
            padding: $size-12 $size-14;
    }

.iban-acct-empty {
            padding: $size-12;
            border-radius: $size-12;
            margin-bottom: $size-10;
    }

.iban-acct-create {
            margin-top: $size-10;
    }

.iban-acct-create svg,
.iban-ghost-back svg {
            width: $size-14;
            height: $size-14;
    }

.iban-fee-strip {
            gap: $size-24;
            border-radius: $size-12;
            padding: $size-16 $size-18;
            margin-top: $size-12-5;
    }

.iban-fee-strip-row {
            gap: $size-24;
            margin-bottom: $size-6;
    }

.iban-fee-strip-row:last-child,
.iban-fee-row:last-child {
            margin-bottom: 0;
    }

.iban-btn-row {
            gap: $size-12;
            margin-top: $size-15;
    }

.iban-confirm-grid {
            gap: $size-24;
    }

.iban-panel-label {
            margin-bottom: $size-6;
    }

.iban-fee-card {
            border-radius: $size-12;
            padding: $size-18;
            margin-bottom: $size-18;
    }

.iban-fee-row {
            margin-bottom: $size-8;
    }

.iban-fee-row.total {
            padding-top: $size-12;
            margin-top: $size-12;
    }

.iban-fee-note {
            margin-top: $size-12;
            padding: $size-10 $size-14;
            border-radius: $size-8;
    }

.iban-recurring-fee,
.iban-free-banner,
.iban-warn-banner,
.iban-display {
            border-radius: $size-12;
            padding: $size-14 $size-16;
    }

.iban-recurring-fee,
.iban-free-banner {
            margin-bottom: $size-18;
    }

.iban-recurring-label {
            margin-bottom: $size-4;
    }

.iban-recurring-sub {
            margin-top: $size-4;
    }

.iban-warn-banner {
            margin-top: $size-16;
            gap: $size-12;
    }

.iban-warn-icon {
            width: $size-26;
            height: $size-26;
    }

.iban-pay-from {
            margin-bottom: $size-4;
    }

.iban-summary-rows {
            margin-bottom: $size-18;
    }

.iban-summary-row {
            padding: $size-11 0;
    }

.iban-summary-val {
            gap: $size-6;
    }

.iban-fine-print {
            margin-top: $size-12;
    }

.iban-ghost-back {
            margin-top: $size-12;
    }

.iban-questionnaire-head {
            margin-bottom: $size-12-5;
    }

.iban-questionnaire-title {
            margin-bottom: $size-6;
    }

.iban-questionnaire-form {
            gap: $size-10 $size-12-5;
    }

.iban-field {
            gap: $size-6;
    }

.iban-field-req {
            margin-left: $size-3;
    }

.iban-status-body {
            padding: $size-5 $size-7-5;
    }

.iban-status-icon {
            width: $size-68;
            height: $size-68;
            margin: 0 auto $size-18;
    }

.iban-status-icon svg {
            width: $size-34;
            height: $size-34;
    }

.iban-status-title {
            margin-bottom: $size-6;
    }

.iban-status-sub {
            margin-bottom: $size-20;
    }

.iban-display {
            margin-bottom: $size-14;
            gap: $size-12;
    }

.iban-details {
            border-radius: $size-12;
            margin-bottom: $size-16;
    }

.iban-detail-row {
            gap: $size-12;
            padding: $size-11 $size-14;
    }

.iban-status-actions {
            gap: $size-10;
            margin-top: $size-8;
    }

.iban-fee-terms-modal {
            max-width: $size-500;
            padding: $size-20 $size-22-5;
    }

.iban-fee-terms-title {
            margin-bottom: $size-14;
    }

.iban-fee-terms-body {
            max-height: $size-340;
            margin-bottom: $size-18;
    }

.iban-fee-terms-body p {
            margin-bottom: $size-10;
    }

      @media (max-width: 480px) {
                .iban-fee-strip-values {
                        width: 100%;
                    }
                .iban-fee-strip-row {
                        gap: $size-8;
                    }
          }

.iban-flow-overlay {
            background: var(--iban-overlay-bg);
            color: var(--iban-text);
            font-size: var(--font-size-base);
    }

.iban-flow-modal {
            background: var(--iban-surface);
            box-shadow: var(--shadow-iban-dialog);
    }

.iban-flow-head h1 {
            font-size: var(--font-size-xl);
            font-weight: 700;
            letter-spacing: -0.01em;
            margin: 0;
    }

.iban-step {
            color: var(--iban-text-3);
            font-weight: 500;
            font-size: var(--font-size-sm);
    }

.iban-step-marker {
            border-color: var(--iban-border-strong);
            font-size: var(--font-size-sm);
            font-weight: 600;
    }

.iban-step.active {
            color: var(--iban-blue);
    }

:where(.iban-step).active .iban-step-marker,
:where(.iban-setup-section).active .iban-step-marker {
            border-color: var(--iban-blue);
            color: var(--iban-blue);
            background: var(--iban-blue-soft);
    }

.iban-step.done {
            color: var(--iban-text);
    }

:where(.iban-step).done .iban-step-marker,
:where(.iban-setup-section).complete .iban-step-marker {
            border-color: var(--iban-green);
            background: var(--iban-green);
            color: var(--iban-surface);
    }

.iban-step-arrow {
            color: var(--iban-text-3);
            font-size: var(--font-size-sm);
    }

.iban-setup-section {
            border-bottom-color: var(--iban-border);
    }

.iban-section-title {
            font-weight: 600;
            font-size: var(--font-size-base);
    }

.iban-section-badge {
            background: var(--iban-surface-2);
            color: var(--iban-text-2);
    }

.iban-choice-card {
            background: var(--iban-surface);
            border-color: var(--iban-border-strong);
    }

.iban-choice-card:hover {
            border-color: var(--iban-blue);
    }

.iban-choice-card.selected {
            border-color: var(--iban-blue);
            background: var(--iban-blue-soft);
    }

.iban-net-icon {
            color: var(--iban-surface);
            font-weight: 700;
            font-size: var(--font-size-xs);
            letter-spacing: 0.5px;
    }

.iban-net-icon.sepa {
            background: linear-gradient(135deg, var(--iban-sepa-grad-1), var(--iban-sepa-grad-2));
    }

.iban-net-icon.swift {
            background: linear-gradient(135deg, var(--iban-swift-grad-1), var(--iban-swift-grad-2));
    }

.iban-net-icon.local {
            background: linear-gradient(135deg, var(--iban-local-grad-1), var(--iban-local-grad-2));
    }

.iban-net-title {
            font-weight: 600;
            font-size: var(--font-size-base);
    }

.iban-choice-meta {
            color: var(--iban-text-2);
            font-size: var(--font-size-sm);
    }

.iban-choice-check {
            background: var(--iban-blue);
            color: var(--iban-surface);
    }

.iban-acct-name {
            font-weight: 600;
            font-size: var(--font-size-base);
    }

.iban-acct-empty {
            background: var(--iban-surface-2);
            color: var(--iban-text-2);
            font-size: var(--font-size-base);
    }

.iban-fee-strip {
            background: var(--iban-surface-2);
    }

.iban-fee-strip-note {
            line-height: 1.6;
            font-size: var(--font-size-sm);
            color: var(--iban-text-2);
    }

.iban-fee-strip-label {
            font-size: var(--font-size-sm);
            color: var(--iban-text-2);
    }

.iban-fee-strip-val {
            font-weight: 700;
            font-size: var(--font-size-base);
    }

.iban-fee-strip-val.free {
            color: var(--iban-green);
    }

.iban-panel-label {
            font-size: var(--font-size-base);
            font-weight: 600;
    }

.iban-fee-card {
            background: var(--iban-surface-2);
    }

.iban-fee-row.total {
            border-top-color: var(--iban-border-strong);
    }

.iban-fee-label {
            color: var(--iban-text-2);
            font-size: var(--font-size-base);
    }

.iban-fee-value {
            font-weight: 600;
            font-size: var(--font-size-base);
    }

.iban-fee-value.total-val {
            font-size: var(--font-size-xl);
            font-weight: 700;
    }

.iban-fee-note {
            background: var(--iban-green-soft);
            color: var(--iban-green-text);
            font-size: var(--font-size-sm);
    }

.iban-recurring-fee {
            background: var(--iban-surface-2);
    }

.iban-recurring-label {
            font-size: var(--font-size-sm);
            color: var(--iban-text-2);
            font-weight: 600;
    }

.iban-recurring-amount {
            font-size: var(--font-size-lg);
            font-weight: 700;
    }

.iban-recurring-amount .iban-recurring-cadence {
            font-size: var(--font-size-sm);
            font-weight: 500;
            color: var(--iban-text-2);
    }

.iban-recurring-sub {
            line-height: 1.5;
            color: var(--iban-text-2);
            font-size: var(--font-size-sm);
    }

.iban-free-banner {
            background: var(--iban-green-soft);
            border-color: var(--iban-green-border);
            color: var(--iban-green-text);
            font-weight: 500;
            font-size: var(--font-size-base);
    }

.iban-warn-banner {
            background: var(--iban-red-soft);
            border-color: var(--iban-warn-border);
            color: var(--iban-warn-text);
    }

.iban-warn-icon {
            background: var(--iban-red);
            color: var(--iban-surface);
            font-weight: 700;
            font-size: var(--font-size-base);
    }

.iban-warn-text {
            line-height: 1.5;
            font-size: var(--font-size-sm);
    }

.iban-summary-row {
            border-bottom-color: var(--iban-border);
    }

.iban-summary-key {
            color: var(--iban-text-2);
            font-size: var(--font-size-base);
    }

.iban-summary-val {
            font-weight: 600;
            font-size: var(--font-size-base);
    }

.iban-fine-print {
            font-size: var(--font-size-sm);
            color: var(--iban-text-3);
    }

.iban-fine-print .iban-link {
            color: var(--iban-blue);
            text-decoration: underline;
    }

.iban-questionnaire-title {
            font-size: var(--font-size-base);
            font-weight: 600;
    }

.iban-questionnaire-subtitle {
            line-height: 1.6;
            color: var(--iban-text-2);
            font-size: var(--font-size-base);
    }

.iban-field-label {
            line-height: 1.4;
            font-size: var(--font-size-sm);
            font-weight: 500;
            color: var(--iban-text-2);
    }

.iban-field-req {
            color: var(--iban-red);
    }

.iban-status-icon {
            color: var(--iban-surface);
    }

.iban-status-icon.issued {
            background: var(--iban-green);
    }

.iban-status-icon.pending {
            background: var(--iban-amber);
    }

.iban-status-icon.failed {
            background: var(--iban-red);
    }

.iban-status-title {
            font-size: var(--font-size-xl);
            font-weight: 700;
    }

.iban-status-sub {
            color: var(--iban-text-2);
            font-size: var(--font-size-base);
    }

.iban-display {
            background: var(--iban-surface-2);
    }

.iban-string {
            letter-spacing: 0.5px;
            font-family: 'SF Mono', Menlo, monospace;
            font-size: var(--font-size-base);
    }

.iban-details {
            border-color: var(--iban-border);
    }

.iban-detail-row {
            font-size: var(--font-size-sm);
            border-bottom-color: var(--iban-border);
    }

.iban-detail-label {
            color: var(--iban-text-2);
    }

.iban-detail-value {
            font-weight: 600;
    }

.iban-fee-terms-modal {
            width: var(--modal-fill-inline-size);
    }

.iban-fee-terms-title {
            font-size: var(--font-size-lg);
            font-weight: 700;
            color: var(--iban-text);
    }

.iban-fee-terms-body {
            color: var(--iban-text-2);
            font-size: var(--font-size-base);
            line-height: 1.7;
    }

.iban-fee-terms-body strong {
            color: var(--iban-text);
    }
} // layer app
